
	import Component from 'vue-class-component'
	import moduleStore from './store/CourseRule';
	import Vue from 'vue';
	import PageState from './store/state';


	/**components**/
	@Component({})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class CourseRulePage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
		created(moduleData:IinjectDatas) {
			this.state = <PageState>moduleData.state;
		}
		mounted(moduleData:IinjectDatas){
			/*this.$http("getDataList",{}).then((response:any)=>{
				console.log(response)
			}).catch((ex:any)=>{
				console.log(ex)
			})*/
	
			this.state.title="这是更改后的title"
			this.state.self = this;
		}
	
	}